<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-12 __zoom-out-ttl">
        <div class="outer-tatalaksana">
          <div class="row">
            <div class="col-md-1">
              <img src="@/assets/img/alert.png" width="40" height="40" />
            </div>
            <div class="col-md-11">
              <span>Alergi & Kondisi Khusus:</span>
              <br />
              <span
                v-for="(v, i) in alergiKondisiKhusus"
                :key="i"
                :class="v.class"
                >{{ v.label }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-3">
      <div class="col-md-6">
        <button
          v-if="hasFeatures('all')"
          @click="modalRecipe()"
          class="btn btn-recipe"
          :disabled="checkNoRecipe()"
        >
          Buat Resep
        </button>
        <button
          v-if="hasFeatures('all') && checkCopyRecipe()"
          @click="printCopyRecipe()"
          class="btn btn-copy-recipe ml-4"
        >
          Cetak Resep
        </button>
      </div>
      <div
        class="col-md-6 d-flex justify-content-end pl-0"
        v-if="checkNoRecipe()"
      >
        <span class="mt-2" style="font-size: 0.725rem;">{{
          dataRecipe.transklinik
            ? renameRecipe(dataRecipe.transklinik.no_resep)
            : "-"
        }}</span>
        <div container="body" class="ml-3 d-inline-block">
          <b-dropdown
            id="action-resep"
            right
            no-flip
            variant="outline-success"
            size="sm"
            class="p-0"
            text="Actions"
          >
            <b-dropdown-item
              @click="getRecipe('edit')"
              v-if="hasFeatures('all')"
              >Edit</b-dropdown-item
            >
            <b-dropdown-item
              @click="downloadRecipe('download')"
              v-if="hasFeatures('all') || hasFeatures('cetak')"
              >Download</b-dropdown-item
            >
            <b-dropdown-item
              @click="previewRecipe('view')"
              v-if="hasFeatures('all') || hasFeatures('preview')"
              >Preview</b-dropdown-item
            >
            <b-dropdown-item @click="deleteRecipe" v-if="hasFeatures('all')"
              >Delete</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <hr />

    <b-col md="12" v-if="trx.kategori_id == 2">
      <label class="text-header m-0">Ditanggung BPJS</label>
    </b-col>

    <!-- Tindakan & Obat oleh BPJS -->
    <b-col md="12" class="mt-5 mb-3" v-if="trx.kategori_id == 2">
      <label class="text-title m-0">Tindakan</label>
    </b-col>
    <b-col md="12" v-if="trx.kategori_id == 2">
      <DataTableWrapper
        :perPage="perPageTindakan"
        :fromPage="fromPageTindakan"
        :toPage="toPageTindakan"
        :totalEntries="totalEntriesTindakan"
        :currentPage="currentPageTindakan"
        :callbackFunc="fetchListTindakanBpjs"
        @valueChanged="handleValueChangedTindakanBpjs"
      >
        <template v-slot:right-header>
          <b-button
            variant="success"
            class="text-uppercase align-self-end mr-3"
            @click="openTindakanBpjsForm()"
          >
            Tambah
          </b-button>
        </template>
        <b-table
          :items="tindakanBpjsList"
          :fields="fieldListTindakan"
          :current-page="currentPageTindakan"
          :per-page="perPageTindakan"
          :busy="isBusyTinddakan"
          thead-tr-class="izd-datatable"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <!-- HEADER SLOT -->
          <template v-slot:head()="data">
            {{ data.label }}
            <b-input
              size="sm"
              class="mt-2 w-95"
              v-if="data.field.searchable"
              @input="searchValueChanged($event, data.field.key)"
            />
          </template>

          <template v-slot:head(keterangan)="data">
            {{ data.label }}
          </template>

          <template v-slot:cell(action)="data">
            <div
              class="text-center"
              style="cursor: pointer"
              @click="deleteTindakanBpjs(data.item.code)"
            >
              <font-awesome-icon icon="trash" />
            </div>
          </template>
        </b-table>
      </DataTableWrapper>
    </b-col>

    <!-- Modal Add Tindakan -->
    <b-modal
      ref="form-tindakan"
      size="xl"
      hide-footer
      :no-close-on-backdrop="true"
      title="Tambah Tindakan"
    >
      <div class="d-block">
        <b-row>
          <b-col sm="4">
            <label for="" class="text-subtitle">Nama Tindakan</label>
            <vue-select-clearable
              class="select_layanan"
              :options="optionTindakanBpjs"
              v-model="formTindakanBpjs.code"
              placeholder="Pilih Tindakan"
              :keyOpt="'tindakanBpjs'"
              @input="inputTindakanBpjs($event)"
            >
            </vue-select-clearable>
            <div
              v-if="formTindakanBpjs.errors.code.status"
              class="text-danger text-left"
            >
              {{ formTindakanBpjs.errors.code.message || "-" }}
            </div>
          </b-col>
          <b-col sm="2" class="form-group">
            <label for="" class="text-subtitle">QTY</label>
            <input
              id="qtyTindakan"
              min="1"
              type="number"
              class="form-control"
              v-model="formTindakanBpjs.quantity"
              @keypress="checkInput"
            />
          </b-col>
          <b-col sm="2" class="form-group">
            <label for="" class="text-subtitle">Max Tarif</label>
            <input
              id="maxTarifTindakan"
              type="text"
              class="form-control"
              v-model="formTindakanBpjs.max_tarif"
              v-money="money"
              :disabled="true"
            />
          </b-col>
          <b-col sm="4">
            <label for="" class="text-subtitle">Keterangan</label>
            <input
              id="descTindakan"
              type="text"
              class="form-control"
              placeholder="Keterangan"
              v-model="formTindakanBpjs.keterangan"
            />
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col sm="12" class="text-right">
          <b-button
            class="mt-3 mr-3"
            variant="danger"
            @click="closeTindakanBpjsForm"
            >Batal</b-button
          >
          <b-button class="mt-3" variant="info" @click="addTindakanBpjs()"
            >Simpan</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- End Modal Tindakan -->

    <!-- Obat BPJS -->
    <b-col md="12" class="mt-5 mb-3" v-if="trx.kategori_id == 2">
      <label class="text-title m-0">Obat</label>
    </b-col>
    <b-col md="12" v-if="trx.kategori_id == 2">
      <DataTableWrapper
        :perPage="perPageObat"
        :fromPage="fromPageObat"
        :toPage="toPageObat"
        :totalEntries="totalEntriesObat"
        :currentPage="currentPageObat"
        :callbackFunc="fetchListObatBpjs"
        @valueChanged="handleValueChangedObatBpjs"
      >
        <template v-slot:right-header>
          <b-button
            variant="success"
            class="text-uppercase align-self-end mr-3"
            @click="openObatBpjsForm()"
          >
            Tambah
          </b-button>
        </template>
        <b-table
          :items="obatBpjsList"
          :fields="fieldListObat"
          :current-page="currentPageObat"
          :per-page="perPageObat"
          :busy="isBusyObat"
          thead-tr-class="izd-datatable"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:head()="data">
            {{ data.label }}
            <b-input
              size="sm"
              class="mt-2 w-95"
              v-if="data.field.searchable"
              @input="searchObatValueChanged($event, data.field.key)"
            />
          </template>

          <template v-slot:head(keterangan)="data">
            {{ data.label }}
          </template>

          <template v-slot:cell(nama)="data">
            {{ data.item.nama }} - ({{ data.item.code }})
          </template>

          <template v-slot:cell(nama_izidok)="data">
            {{ data.item.nama_izidok }}
          </template>

          <template v-slot:cell(action)="data">
            <div
              class="text-center"
              style="cursor: pointer"
              @click="deleteObatBpjs(data.item.code)"
            >
              <font-awesome-icon icon="trash" />
            </div>
          </template>
        </b-table>
      </DataTableWrapper>
    </b-col>
    <!-- Modal Add Obat -->
    <b-modal
      ref="form-obat"
      size="xl"
      hide-footer
      :no-close-on-backdrop="true"
      title="Tambah Obat"
    >
      <div class="d-block">
        <b-row>
          <b-col sm="3">
            <label for="" class="text-subtitle">Nama Obat BPJS</label>
            <vue-select-clearable
              class="select_layanan"
              :options="optionObatBpjs"
              v-model="formObatBpjs.code"
              placeholder="Pilih Obat"
              :keyOpt="'tindakanBpjs'"
              @search="searchObatBpjs"
              @input="inputObatBpjs($event)"
            >
            </vue-select-clearable>
            <div
              v-if="formObatBpjs.errors.code.status"
              class="text-danger text-left"
            >
              {{ formObatBpjs.errors.code.message || "-" }}
            </div>
          </b-col>
          <b-col sm="3">
            <label for="" class="text-subtitle"
              >Nama Obat izidok
              <font-awesome-layers
                class="ml-2"
                style="font-size: 100%;"
                v-tooltip="{
                  placement: 'top',
                  classes: 'info-tooltip',
                  content: `Mengisi nama obat izidok, maka akan memperbarui stok pada obat terpilih`
                }"
              >
                <font-awesome-icon
                  :icon="['far', 'circle']"
                  style="opacity: 0.3;color: #3772d7"
                />
                <font-awesome-icon
                  :icon="['fas', 'info']"
                  transform="shrink-8"
                  style="color: #3772d7"
                />
              </font-awesome-layers>
            </label>
            <vue-select-clearable
              class="select_layanan"
              :options="optionObatBpjsIzidok"
              v-model="formObatBpjs.codeIzidok"
              placeholder="Pilih Obat/ BHP"
              @search="searchObatBpjsIzidok"
              @input="inputObatBpjsIzidok($event)"
            >
            </vue-select-clearable>
            <div
              v-if="formObatBpjs.errors.codeIzidok.status"
              class="text-danger text-left"
            >
              {{ formObatBpjs.errors.codeIzidok.message || "-" }}
            </div>
          </b-col>
          <b-col sm="2" class="form-group">
            <label for="" class="text-subtitle">QTY</label>
            <input
              id="qtyObat"
              min="1"
              type="number"
              class="form-control"
              v-model="formObatBpjs.quantity"
              @keypress="checkInput"
              @input="checkQuantity"
            />
          </b-col>
          <b-col sm="2" class="form-group">
            <label for="" class="text-subtitle">Sedia</label>
            <input
              id="sediaObat"
              type="text"
              class="form-control"
              v-model="formObatBpjs.sedia"
              :disabled="true"
            />
          </b-col>
          <b-col sm="2">
            <label for="" class="text-subtitle">Keterangan</label>
            <input
              id="descObat"
              type="text"
              class="form-control"
              placeholder="Keterangan"
              v-model="formObatBpjs.keterangan"
            />
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col sm="12" class="text-right">
          <b-button
            class="mt-3 mr-3"
            variant="danger"
            @click="closeObatBpjsForm"
            >Batal</b-button
          >
          <b-button class="mt-3" variant="info" @click="addObatBpjs()"
            >Simpan</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- End Modal Obat -->

    <!-- Terapi Obat -->
    <b-col md="12 mt-5" v-if="trx.kategori_id == 2">
      <div class="d-flex">
        <label class="text-title m-0">Terapi Obat</label>
        <span style="color:red"> *</span>
      </div>
    </b-col>

    <b-col md="12" v-if="trx.kategori_id == 2">
      <b-form-group
        id="fieldset-1"
        valid-feedback=""
        :invalid-feedback="terapiObatInvalidFeedback"
        :state="stateTerapiObat"
      >
        <b-form-textarea
          id="textarea"
          v-model="terapiObat"
          placeholder=""
          :state="stateTerapiObat"
          rows="3"
          max-rows="6"
          @keyup="terapiObatKeyupHanlder"
          @input="terapiObatInputHanlder"
        ></b-form-textarea>
      </b-form-group>
    </b-col>
    <!-- End Terapi Obat -->

    <!-- Terapi Non Obat -->
    <b-col md="12 mt-5" v-if="trx.kategori_id == 2">
      <div class="d-flex">
        <label class="text-title m-0">Terapi Non Obat</label>
        <span style="color:red"> *</span>
      </div>
    </b-col>

    <b-col md="12" v-if="trx.kategori_id == 2">
      <b-form-group
        id="fieldset-1"
        valid-feedback=""
        :invalid-feedback="terapiNonObatInvalidFeedback"
        :state="stateTerapiNonObat"
      >
        <b-form-textarea
          id="textarea"
          v-model="terapiNonObat"
          placeholder=""
          :state="stateTerapiNonObat"
          rows="3"
          max-rows="6"
          @keyup="terapiNonObatKeyupHanlder"
          @input="terapiNonObatInputHanlder"
        ></b-form-textarea>
      </b-form-group>
    </b-col>
    <!-- End Terapi Non Obat -->

    <!-- BMHP -->
    <b-col md="12 mt-5" v-if="trx.kategori_id == 2">
      <div class="d-flex">
        <label class="text-title m-0">BMHP</label>
      </div>
    </b-col>

    <b-col md="12" v-if="trx.kategori_id == 2">
      <b-form-group
        id="fieldset-1"
        valid-feedback=""
      >
        <b-form-textarea
          id="textarea"
          v-model="bmhp"
          placeholder=""
          rows="3"
          max-rows="6"
          @input="bmhpInputHanlder"
        ></b-form-textarea>
      </b-form-group>
    </b-col>
    <!-- End BMHP -->

    <!-- End tindakan & obat oleh BPJS -->

    <div class="row mt-5 mb-5">
      <b-col md="12" v-if="trx.kategori_id == 2">
        <label class="text-header m-0">Tidak Ditanggung BPJS</label>
      </b-col>

      <!-- Tindakan -->
      <div class="col-md-12 mt-3">
        <div class="form-row">
          <div class="form-group col-md-8">
            <label class="text-subtitle">Tindakan</label>
          </div>
          <div class="form-group col-md-1">
            <label class="text-subtitle">Qty</label>
          </div>
          <div class="form-group col-md-3">
            <label class="text-subtitle">Catatan</label>
          </div>
        </div>
        <div
          class="form-row"
          v-for="(inputTindakan, index) in tmpInputLayanan.filter(
            t => t.type == 'tindakan'
          )"
          :key="index"
        >
          <div class="form-group col-md-8">
            <div class="media">
              <div style="width:50px;">&nbsp;</div>
              <div class="media-body pr-0">
                <vue-select-clearable
                  class="select_layanan"
                  :options="optionLayananTindakan"
                  v-model="inputTindakan.selectedLayanan"
                  placeholder="Pilih Tindakan"
                  @search="getLayananTindakan"
                  @input="setLayanan()"
                  :disabled="disabledTindakan"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.label }}
                  </template>
                </vue-select-clearable>
              </div>
            </div>
          </div>
          <div class="form-group col-md-1 pl-2">
            <input
              type="number"
              class="form-control"
              min="1"
              v-model="inputTindakan.qty"
              @input="setLayanan()"
              :disabled="disabledTindakan"
              @keypress="checkInput"
            />
          </div>
          <div class="form-group col-md-2 pl-2">
            <input
              placeholder="Masukan catatan"
              type="text"
              class="form-control"
              :value="
                disabledTindakan
                  ? inputTindakan.keterangan || '-'
                  : inputTindakan.keterangan
              "
              @input="
                event => {
                  inputTindakan.keterangan = event.target.value;
                  setLayanan();
                }
              "
              :disabled="disabledTindakan"
            />
          </div>
          <div class="form-group col-md-1 d-flex align-items-start mt-2">
            <div class="mb-1">
              <b-button
                variant="first"
                style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;"
                @click="addInputLayanan('tindakan')"
                :disabled="disabledTindakan"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
              <b-button
                v-if="index > 0"
                variant="danger"
                style="padding: 0.1rem 0.3rem;border-radius: 100%;margin-left: 0.3rem;"
                @click="removeLayanan(index, 'tindakan')"
                :disabled="disabledTindakan"
              >
                <font-awesome-icon icon="minus" />
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Obat / BHP -->
      <div class="col-md-12 mt-3">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label class="text-subtitle">Obat/bahan habis pakai</label>
          </div>
          <div class="form-group col-md-1">
            <label class="text-subtitle">Qty</label>
          </div>
          <div class="form-group col-md-2">
            <label class="text-subtitle">Satuan</label>
          </div>
          <div class="form-group col-md-2">
            <label class="text-subtitle">Aturan Pakai</label>
          </div>
          <div class="form-group col-md-3">
            <label class="text-subtitle">Catatan</label>
          </div>
        </div>
        <div
          class="form-row"
          v-for="(inputTindakan, index) in tmpInputLayanan.filter(
            t => t.type == 'obat_bhp'
          )"
          :key="index"
        >
          <div class="form-group col-md-4">
            <div class="media">
              <div class="mt-2" style="width:50px;">
                <b-form-checkbox
                  v-model="inputTindakan.checkbox"
                  class="text-center"
                  @input="setLayanan()"
                  :disabled="
                    checkSelectedLayanan(inputTindakan.selectedLayanan)
                  "
                ></b-form-checkbox>
              </div>
              <div class="media-body pr-0">
                <vue-select-clearable
                  class="select_layanan"
                  :options="optionLayananObatBHP"
                  v-model="inputTindakan.selectedLayanan"
                  placeholder="Pilih Obat/Bahan Habis Pakai"
                  @search="getLayananObatBHP"
                  @input="setLayanan()"
                  :disabled="disabledTindakan"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.label }}
                  </template>
                </vue-select-clearable>
              </div>
            </div>
            <small
              v-if="checkStock(index)"
              class="form-text invalid-feedback"
              style="display: block;"
            >
              Stok kurang/habis.
            </small>
          </div>
          <div class="form-group col-md-1 pl-2">
            <input
              type="number"
              class="form-control"
              min="1"
              v-model="inputTindakan.qty"
              @input="setLayanan()"
              :disabled="disabledTindakan"
              @keypress="checkInput"
            />
          </div>
          <div class="form-group col-md-2 pl-2">
            <input
              class="form-control"
              v-model="inputTindakan.satuan"
              v-tooltip="inputTindakan.satuan !== '-' && inputTindakan.satuan"
              readonly="readonly"
            />
          </div>
          <div class="form-group col-md-2 pl-2">
            <input
              type="text"
              class="form-control"
              :value="
                disabledTindakan
                  ? inputTindakan.aturan_pakai || '-'
                  : inputTindakan.aturan_pakai
              "
              @input="
                event => {
                  inputTindakan.aturan_pakai = event.target.value;
                  setLayanan();
                }
              "
              :disabled="disabledTindakan"
            />
          </div>
          <div class="form-group col-md-2 pl-2">
            <input
              placeholder="Masukan catatan"
              type="text"
              class="form-control"
              :value="
                disabledTindakan
                  ? inputTindakan.keterangan || '-'
                  : inputTindakan.keterangan
              "
              @input="
                event => {
                  inputTindakan.keterangan = event.target.value;
                  setLayanan();
                }
              "
              :disabled="disabledTindakan"
            />
          </div>
          <div class="form-group col-md-1 d-flex align-items-start mt-2">
            <div class="mb-1">
              <b-button
                variant="first"
                style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;"
                @click="addInputLayanan('obat_bhp')"
                :disabled="disabledTindakan"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
              <b-button
                v-if="index > 0"
                variant="danger"
                style="padding: 0.1rem 0.3rem;border-radius: 100%;margin-left: 0.3rem;"
                @click="removeLayanan(index, 'obat_bhp')"
                :disabled="disabledTindakan"
              >
                <font-awesome-icon icon="minus" />
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Add Recipe -->
    <b-modal
      ref="form-recipe"
      size="xl"
      hide-header
      hide-footer
      :no-close-on-backdrop="true"
    >
      <b-row>
        <b-col sm="12 px-4">
          <ol class="breadcrumb font-size-xs p-0">
            <li class="breadcrumb-item font-weight-bold text-primary">
              Rekam Medis
            </li>
            <li class="breadcrumb-item active">Resep</li>
          </ol>
          <label class="display-4 mb-3 text-header">Resep</label>
        </b-col>
      </b-row>
      <b-card class="card-shadowless card-info">
        <b-row class="info_recipe">
          <b-col sm="6">
            <b-row class="mb-2">
              <b-col sm="4">Nama Pasien</b-col>
              <b-col sm="8">: {{ infoPasien.name }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">Tanggal Lahir</b-col>
              <b-col sm="8">: {{ infoPasien.tanggal_lahir }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">Usia</b-col>
              <b-col sm="8">: {{ infoPasien.usia }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">Jenis Kelamin</b-col>
              <b-col sm="8">: {{ infoPasien.jenis_kelamin }}</b-col>
            </b-row>
          </b-col>
          <b-col sm="6">
            <b-row>
              <b-col sm="4">No. RM</b-col>
              <b-col sm="8">: {{ infoPasien.nomor_rekam_medis }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">Nama Dokter</b-col>
              <b-col sm="8">: {{ infoPasien.dokter_name }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">SIP Dokter</b-col>
              <b-col sm="8">: {{ infoPasien.sip_dokter }}</b-col>
              <b-row class="mb-2"> </b-row>
              <b-col sm="4">Tanggal Resep</b-col>
              <b-col sm="8">: {{ infoPasien.tanggal_resep }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="card-shadowless card-border mt-3">
        <b-row>
          <b-col sm="12" class="min-h">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label class="text-subtitle m-0">Nama Obat & BHP</label>
              </div>
              <div class="form-group col-md-1">
                <label class="text-subtitle m-0">Qty</label>
              </div>
              <div class="form-group col-md-3">
                <label class="text-subtitle m-0">Satuan</label>
              </div>
              <div class="form-group col-md-2">
                <label class="text-subtitle m-0">Aturan Pakai</label>
              </div>
              <div class="form-group col-md-3">
                <label class="text-subtitle m-0">Catatan</label>
              </div>
            </div>
            <div
              class="form-row"
              v-for="(inputRecipe, idx) in tmpInputRecipe"
              :key="idx"
            >
              <div class="form-group col-md-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="inputRecipe.nama_layanan"
                  @input="
                    event => {
                      setLayananRecipe();
                      validateRecipe();
                    }
                  "
                  @keypress="validateRecipe()"
                />
                <small
                  v-if="inputRecipe.error && inputRecipe.error.nama_layanan"
                  class="form-text invalid-feedback"
                  style="display: block;"
                >
                  {{ inputRecipe.error.nama_layanan }}
                </small>
              </div>
              <div class="form-group col-md-1">
                <input
                  type="number"
                  class="form-control pr-2 pl-3"
                  min="1"
                  v-model="inputRecipe.quantity"
                  @input="
                    event => {
                      setLayananRecipe();
                      validateRecipe();
                    }
                  "
                  @keypress="checkInput"
                />
                <small
                  v-if="inputRecipe.error && inputRecipe.error.quantity"
                  class="form-text invalid-feedback"
                  style="display: block;"
                >
                  {{ inputRecipe.error.quantity }}
                </small>
              </div>
              <div class="form-group col-md-3">
                <vue-select-clearable
                  class="select_layanan"
                  placeholder="Pilih Satuan"
                  :options="optSatuan"
                  v-model="inputRecipe.satuan"
                  @input="setLayananRecipe()"
                  :keyOpt="'substring'"
                >
                </vue-select-clearable>
              </div>
              <div class="form-group col-md-2">
                <input
                  type="text"
                  class="form-control"
                  :value="inputRecipe.aturan_pakai"
                  @input="
                    event => {
                      inputRecipe.aturan_pakai = event.target.value;
                      setLayananRecipe();
                    }
                  "
                />
              </div>
              <div class="form-group col-md-2">
                <input
                  placeholder="Masukan catatan"
                  type="text"
                  class="form-control"
                  :value="inputRecipe.keterangan"
                  @input="
                    event => {
                      inputRecipe.keterangan = event.target.value;
                      setLayananRecipe();
                    }
                  "
                />
              </div>
              <div class="form-group col-md-1 d-flex align-items-start mt-2">
                <div class="mb-1" v-if="tmpInputRecipe.length == 1">
                  <b-button
                    variant="first"
                    style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;"
                    @click="addInputLayananRecipe"
                  >
                    <font-awesome-icon icon="plus" />
                  </b-button>
                </div>
                <div class="mb-1" v-else-if="tmpInputRecipe.length > 1">
                  <b-button
                    v-if="idx > 0"
                    variant="first"
                    style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;"
                    @click="addInputLayananRecipe"
                  >
                    <font-awesome-icon icon="plus" />
                  </b-button>
                  <b-button
                    variant="danger"
                    style="padding: 0.1rem 0.3rem;border-radius: 100%;margin-left: 0.3rem;"
                    @click="removeLayananRecipe(idx)"
                  >
                    <font-awesome-icon icon="minus" />
                  </b-button>
                </div>
              </div>
            </div>
          </b-col>
          <b-col sm="5 mt-5">
            <div class="media">
              <img
                class="mr-2 mt-1"
                src="@/assets/img/verified.png"
                alt="verified"
                width="35px"
              />
              <div class="media-body">
                <span class="text-verified">
                  <i
                    >Dokumen resep digital ini sah diterbitkan
                    {{ dataKlinik.name || "[Nama Klinik]" }} dan diproses
                    komputer menggunakan Aplikasi Izidok</i
                  >
                </span>
              </div>
            </div>
          </b-col>
          <b-col sm="12" class="text-right">
            <b-button class="mt-3 mr-3" variant="danger" @click="closeRecipe"
              >Keluar</b-button
            >
            <b-button
              class="mt-3 mr-3"
              variant="info"
              @click="saveRecipe('save')"
              >Simpan</b-button
            >
            <b-button
              class="mt-3"
              variant="primary"
              @click="saveRecipe('cetak')"
              v-if="hasFeatures('all') || hasFeatures('cetak')"
              >Cetak</b-button
            >
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <!-- End Modal Recipe -->

    <b-row>
      <b-col cols="5" class="d-flex align-items-end">
        <label class="text-title m-0">Tindakan, Terapi, dan Saran</label>
      </b-col>
      <b-col cols="7" class="float-right pen-isMobile">
        <div class="row d-flex justify-content-end mr-2">
          <div class="mt-2">
            <span @click="penColor('blue');isColorActive = 'blue'" class="dot grow" style="background-color: blue;"
              :class="{ color_active: isColorActive === 'blue' }"></span>
            <span @click="penColor('red');isColorActive = 'red'" class="dot grow" style="background-color: red;"
              :class="{ color_active: isColorActive === 'red' }"></span>
            <span @click="penColor('#54c756');isColorActive = 'green'" class="dot grow"
              style="background-color: #54c756;" :class="{ color_active: isColorActive === 'green' }"></span>
            <span @click="penColor('#555');isColorActive = 'black'" class="dot grow" style="background-color: #555;"
              :class="{ color_active: isColorActive === 'black' }"></span>
            <span @click="penColor('orange');isColorActive = 'yellow'" class="dot grow"
              style="background-color: orange;" :class="{ color_active: isColorActive === 'yellow' }"></span>
          </div>
          <font-awesome-icon
            icon="eraser"
            class="font-size-xl m-2 grow icon"
            v-on:click="setDrawPostData('eraser');"
            v-show="!isHidden"
            :class="{ active_tool: isActive === 'eraser' }" />
          <font-awesome-icon
            icon="pen-alt"
            class="font-size-xl m-2 grow icon"
            v-on:click="setDrawPostData('pen');"
            :class="{ active_tool: isActive === 'pen' }" />
          <font-awesome-icon
            icon="keyboard"
            class="font-size-xl m-2 grow icon"
            v-on:click="setDrawPostData('keyboard');"
              :class="{ active_tool: isActive === 'keyboard' }" />
        </div>
        <div class="row d-flex justify-content-end mr-2">
          <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidth" />
        </div>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-md-12" v-show="!isHidden">
        <canvas
          id="tatalaksana-canvas"
          ref="canvas"
          @mousedown="handleMousedown"
          @mouseup="handleMouseup"
          @mousemove="handleMousemove"
          @touchstart="handleTouchstart"
          @touchend="handleTouchend"
          @touchmove="handleTouchmove"
          :width="canvasWidth"
          :height="canvasHeight"
          >Your browser does not support the HTML 5 Canvas.</canvas
        >
        <div class="col-md-4">
          <b-button @click="clear" variant="warning" size="sm" class="m-1"
            >Clear</b-button
          >
        </div>
      </div>
      <div class="col-md-12" v-show="isHidden">
        <label></label>
        <Editor
          :editorContent="tatalaksana"
          v-on:update-content="updateContent"
          class="form-tatalaksana"
          :width="contentWidth"
          :height="contentHeight"
        />
      </div>
      <div v-show="!isHidden" class="col-md-12">
        <div id="img_tatalaksana"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { VMoney } from 'v-money';
import { library } from '@fortawesome/fontawesome-svg-core';
import debounce from 'lodash/debounce';
import { faPlus, faMinus, faInfo } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
library.add(faPlus, faMinus, faCircle, faInfo);
import moment from 'moment';
import { toInteger } from 'lodash';
import { result } from 'lodash';

export default {
  components: {
    Editor: () => import('./Editor.vue'),
    'vue-select-clearable': () => import('@/components/VueSelectClearable.vue'),
    DataTableWrapper: () => import('../../../components/DataTableWrapper')
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      money: {
        decimal: '',
        thousands: ',',
        prefix: 'Rp. ',
        suffix: '',
        precision: 0
      },
      isDrawing: false,
      isHidden: true,
      drawing: false,
      mousePos: { x: 0, y: 0 },
      lastPos: { x: 0, y: 0 },
      ctx: null,
      isLoading: false,
      isPen: false,
      isActive: 'keyboard',
      isColorActive: 'black',
      penWidth: 2,
      optionLayananTindakan: [],
      optionLayananObatBHP: [],
      tmpInputLayanan: this.defaultLayanan(),
      ediRekamMedis: {},
      tatalaksana: null,
      imgTatalaksana: null,
      disabledTindakan: false,

      // --- Tindakan BPJS --- //
      perPageTindakan: 5,
      currentPageTindakan: 1,
      fromPageTindakan: 0,
      toPageTindakan: 0,
      totalEntriesTindakan: 0,
      sortByTindakan: '',
      sortDescTindakan: false,
      searchValueTindakan: [],

      formTindakanBpjs: {
        code: null,
        quantity: 1,
        max_tarif: null,
        keterangan: '',
        errors: {
          code: {},
          quantity: {},
          max_tarif: {},
          keterangan: {}
        }
      },
      optionTindakanBpjs: [],
      tindakanBpjsList: [],
      tindakanBpjsListTemp: [],
      fieldListTindakan: [
        {
          key: 'nama',
          label: 'nama tindakan',
          thStyle: 'width:40%',
          searchable: true,
          sortable: true
        },
        {
          key: 'quantity',
          label: 'qty',
          thStyle: 'width:10%',
          tdClass: 'text-center',
          searchable: true,
          sortable: true
        },
        {
          key: 'max_tarif',
          label: 'max tarif',
          thStyle: 'width:20%',
          tdClass: 'text-center',
          searchable: true,
          sortable: true
        },
        {
          key: 'keterangan',
          label: 'keterangan',
          thStyle: 'width:20%',
          sortable: true
        },
        {
          key: 'action',
          label: 'actions',
          thStyle: 'width: 10%'
        }
      ],
      isBusyTinddakan: false,

      // --- Obat BPJS --- //
      perPageObat: 5,
      currentPageObat: 1,
      fromPageObat: 0,
      toPageObat: 0,
      totalEntriesObat: 0,
      sortByObat: '',
      sortDescObat: false,
      searchValueObat: [],
      formObatBpjs: {
        code: null,
        codeIzidok: null,
        stokObatIzidok: null,
        quantity: 1,
        max_tarif: null,
        keterangan: '',
        errors: {
          code: {},
          codeIzidok: {},
          quantity: {},
          max_tarif: {},
          keterangan: {}
        }
      },
      optionObatBpjs: [],
      optionObatBpjsIzidok: [],
      obatBpjsList: [],
      obatBpjsIzidokList: [],
      obatBpjsListTemp: [],
      fieldListObat: [
        {
          key: 'nama',
          label: 'nama obat bpjs',
          thStyle: 'width:25%',
          searchable: true,
          sortable: true
        },
        {
          key: 'nama_izidok',
          label: 'nama obat izidok',
          thStyle: 'width:25%',
          searchable: true,
          sortable: true
        },
        {
          key: 'quantity',
          label: 'qty',
          thStyle: 'width:10%',
          tdClass: 'text-center',
          searchable: true,
          sortable: true
        },
        {
          key: 'sedia',
          label: 'sedia',
          thStyle: 'width:15%',
          tdClass: 'text-center',
          searchable: true,
          sortable: true
        },
        {
          key: 'keterangan',
          label: 'keterangan',
          thStyle: 'width:15%',
          sortable: true
        },
        {
          key: 'action',
          label: 'actions',
          thStyle: 'width: 10%'
        }
      ],
      isBusyObat: false,
      infoPasien: {
        name: null,
        tanggal_lahir: null,
        usia: null,
        jenis_kelamin: null,
        nomor_rekam_medis: null,
        dokter_name: null,
        sip_dokter: null,
        tanggal_resep: null
      },
      tmpInputRecipe: this.defaultRecipe(),
      optSatuan: [],
      dataKlinik: {},
      dataRecipe: {
        detail_pembayaran: null,
        transklinik: null
      },
      recipeErrors: [],
      terapiObat: null,
      terapiNonObat: null,
      bmhp: null,
      pcareVersion: null,
      alergiKondisiKhusus: [],
      tmpInputCopyRecipe: [],
      contentWidth: 1100,
      contentHeight: 500,
      canvasWidth: 1100,
      canvasHeight: 500,
    };
  },
  watch: {
    imgTatalaksana() {
      this.imgTatalaksanaChanged();
    },
    currentPageTindakan(val) {
      this.fetchListTindakanBpjs();
    },
    currentPageObat(val) {
      this.fetchListObatBpjs();
    },
    perPageTindakan() {
      this.fetchListTindakanBpjs();
    },
    perPageObat() {
      this.fetchListObatBpjs();
    },
    searchValueTindakan: {
      handler: 'fetchListTindakanBpjs',
      deep: true
    },
    searchValueObat: {
      handler: 'fetchListObatBpjs'
    },
    postDataUpdated() {
      this.alergiKondisiKhusus = this.setAlergiKondisiKhusus(this.postDataUpdated);
    },
    collapsed() {
      this.resizeWidth(window.innerWidth, this.collapsed);
      this.imgTatalaksana = this.canvas_tatalaksana ? this.canvas_tatalaksana.toDataURL('image/png') : null;
    },
    collapsedMobile() {
      this.resizeWidth(window.innerWidth, this.collapsedMobile);
      this.imgTatalaksana = this.canvas_tatalaksana ? this.canvas_tatalaksana.toDataURL('image/png') : null;
    },
    orientation() {
      this.resizeWidth(window.innerWidth, this.collapsedMobile);
      this.imgTatalaksana = this.canvas_tatalaksana ? this.canvas_tatalaksana.toDataURL('image/png') : null;
    },
  },
  computed: {
    ...mapState(['sidebar']),
    ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
    ...mapGetters([
      'pasien',
      'getKlinikId',
      'trx',
      'klinikUser',
      'getRolesName',
      'canvas_tatalaksana',
    ]),
    canvas() {
      return this.$refs.canvas;
    },
    stateTerapiObat() {
      if (!this.terapiObatTouched) return null;

      if (
        !this.checkValueData(this.terapiObat)
        || (this.checkValueData(this.terapiObat) && this.terapiObat.trim().length < 4)
        || (this.checkValueData(this.terapiObat) && this.terapiObat.trim().length > 255)
      ) {
        return false;
      }

      return null;
    },
    terapiObatInvalidFeedback(){
      if (this.terapiObat) {
        if (this.terapiObat.trim().length < 4) return 'Minimal 4 karakter';
        else if (this.terapiObat.trim().length > 255) return 'Maksimal 255 karakter';
      }
      return '';
    },
    stateTerapiNonObat() {
      if (!this.terapiNonObatTouched)  return null;

      if (
        !this.checkValueData(this.terapiNonObat)
        || (this.checkValueData(this.terapiNonObat) && this.terapiNonObat.trim().length < 4)
        || (this.checkValueData(this.terapiNonObat) && this.terapiNonObat.trim().length > 255)
      ) {
        return false;
      }

      return null;
    },
    terapiNonObatInvalidFeedback(){
      if (this.terapiNonObat) {
        if (this.terapiNonObat.length < 4) return 'Minimal 4 karakter';
        else if (this.terapiNonObat.trim().length > 255) return 'Maksimal 255 karakter';
      }
      return '';
    },
  },
  props: {
    terapiObatTouched: {
      type: Boolean,
      required: false
    },
    terapiNonObatTouched: {
      type: Boolean,
      required: false
    },
    initialData:{
      type: Object,
      required: false
    },
    postDataUpdated: {
      type: Object,
      required: false
    },
  },
  async mounted() {
    await this.resizeWidth(window.innerWidth, this.collapsed);

    this.getLayananTindakan();
    this.getLayananObatBHP();
    this.getOptionTindakanBpjs();
    this.ctx = this.canvas.getContext('2d');
    this.ctx.strokeStyle = '#222222';
    this.ctx.lineWidth = this.penWidth;
    this.ctx.lineJoin = 'round';
    this.ctx.lineCap = 'round';

    //append data canvas to vuex global state
    this.updateCanvas({ key: 'TATALAKSANA', value: this.canvas });
    this.updatePostData({ key: 'tatalaksana_is_draw', value: false });
    this.updatePostData({ key: 'lunas', value: false });

    // Get a regular interval for drawing to the screen
    window.requestAnimFrame = (function(callback) {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimaitonFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();
    // Prevent scrolling when touching the canvas
    document.body.addEventListener(
      'touchstart',
      function(e) {
        if (e.target == document.getElementById('tatalaksana-canvas')) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      'touchend',
      function(e) {
        if (e.target == document.getElementById('tatalaksana-canvas')) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      'touchmove',
      function(e) {
        if (e.target == document.getElementById('tatalaksana-canvas')) {
          e.preventDefault();
        }
      },
      false
    );
    this.getSatuan();
    this.klinik();
    this.getRecipe('view');

    this.getOptionObatBpjsIzidok();
    this.terapiObat = this.initialData.terapiObat;
    this.terapiNonObat = this.initialData.terapiNonObat;
    this.bmhp = this.initialData.bmhp;
    this.pcareVersion = this.initialData.pcareVersion;

    this.ediRekamMedis = localStorage.getItem('edit_rekam_medis');
    if (this.ediRekamMedis != null) this.setTatalaksanaData(JSON.parse(this.ediRekamMedis));

    this.alergiKondisiKhusus = this.setAlergiKondisiKhusus(this.pasien);
  },
  methods: {
    ...mapActions(['updatePostData', 'updateCanvas']),
    resizeWidth(w, collapsed = false) {
      let x = 1.415;

      let zoom = w / 19.2;
      if (collapsed) {
        if (zoom < 100) {
          if (this.orientation == 'portrait') x = 1.25;
          else x = 1.525;
        } else x = 1.2;
      } else if (zoom < 100) {
        if (this.orientation == 'portrait') x = 1.9;
        else x = 1.7;
      }
        
      this.canvasWidth = this.contentWidth = w / x;
      this.canvasHeight = this.canvasWidth * 0.3125;
      this.contentHeight = this.canvasHeight * 0.9;
    },
    updateContent(content) {
      this.updatePostData({ key: 'tatalaksana_text', value: content });
    },
    async getOptionTindakanBpjs() {
      try {
        const res = await this.$axios.get(
          `bpjs/referensi-tindakan?klinik_id=${this.getKlinikId}`
        );

        this.optionTindakanBpjs = res.data.response.list.map(item => {
          return {
            id: item.kdTindakan,
            label: `${item.kdTindakan} - ${item.nmTindakan}`,
            name: item.nmTindakan,
            maxTarif: item.maxTarif
          };
        });
      } catch (error) {}
    },
    async getOptionObatBpjs(val = '') {
      try {
        const res = await this.$axios.get(
          `bpjs/obat/dpho?klinik_id=${this.getKlinikId}&codeOrName=${val}&first_row=0&limit=10`
        );

        this.optionObatBpjs = res.data.response.list.map(item => {
          return {
            id: item.kdObat,
            label: `${item.kdObat} - ${item.nmObat}`,
            name: item.nmObat,
            sedia: item.sedia
          };
        });
      } catch (error) {}
    },
    searchValueChanged(val, key) {
      const { searchValueTindakan } = this;
      this.tindakanBpjsList = this.tindakanBpjsListTemp;

      const keyWord = searchValueTindakan.filter(item => item.key !== key);

      this.searchValueTindakan = [
        ...keyWord,
        {
          key,
          value: val
        }
      ];
    },
    searchObatValueChanged(val, key) {
      const { searchValueObat } = this;
      this.obatBpjsList = this.obatBpjsListTemp;

      const keyWord = searchValueObat.filter(item => item.key !== key);
      this.searchValueObat = [
        ...keyWord,
        {
          key,
          value: val
        }
      ];
    },
    async fetchListTindakanBpjs() {
      this.isBusyTinddakan = true;
      let response = await new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.searchValueTindakan.length > 0) {
            this.tindakanBpjsList = this.tindakanBpjsList.filter(tindakan => {
              let match = [];
              for (const keyWord of this.searchValueTindakan) {
                const rmSpace = keyWord.value.replace(/^\s+|\s+$/g, '');
                const rg = new RegExp(`${rmSpace}`, 'gi');

                if (rg.test(tindakan[keyWord.key])) match.push(true);
                else match.push(false);
              }
              return match.includes(false) ? false : true;
            });
          }
          resolve(this.tindakanBpjsList);
        }, 300);
      });

      this.isBusyTinddakan = false;
      this.tindakanBpjsList = response.map(item => ({ ...item, from_bpjs: 1 }));
      this.totalEntriesTindakan = response.length;

      if (response.length) {
        const maxPage = this.currentPageTindakan * this.perPageTindakan;
        const lastPage = Math.ceil(
          this.totalEntriesTindakan / this.perPageTindakan
        );
        const mod = this.totalEntriesTindakan % this.perPageTindakan;
        this.fromPageTindakan = maxPage - (this.perPageTindakan - 1);
        this.toPageTindakan = mod
          ? this.currentPageTindakan == lastPage
            ? this.fromPageTindakan - 1 + mod
            : maxPage
          : maxPage;
      } else {
        this.fromPageTindakan = this.toPageTindakan = 0;
      }
      return this;
    },
    async fetchListObatBpjs() {
      this.isBusyObat = true;
      let response = await new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.searchValueObat.length > 0) {
            this.obatBpjsList = this.obatBpjsList.filter(obat => {
              let match = [];
              for (const keyWord of this.searchValueObat) {
                const rmSpace = keyWord.value.replace(/^\s+|\s+$/g, '');
                const rg = new RegExp(`${rmSpace}`, 'gi');

                if (rg.test(obat[keyWord.key])) match.push(true);
                else match.push(false);
              }

              return match.includes(false) ? false : true;
            });
          }
          resolve(this.obatBpjsList);
        }, 300);
      });

      this.isBusyObat = false;
      this.obatBpjsList = response.map(item => ({ ...item, from_bpjs: 1 }));
      this.totalEntriesObat = response.length;

      if (response.length) {
        const maxPage = this.currentPageObat * this.perPageObat;
        const lastPage = Math.ceil(this.totalEntriesObat / this.perPageObat);
        const mod = this.totalEntriesObat % this.perPageObat;
        this.fromPageObat = maxPage - (this.perPageObat - 1);
        this.toPageObat = mod
          ? this.currentPageObat == lastPage
            ? this.fromPageObat - 1 + mod
            : maxPage
          : maxPage;
      } else {
        this.fromPageObat = this.toPageObat = 0;
      }
      return this;
    },
    openTindakanBpjsForm() {
      this.formTindakanBpjs = {
        code: null,
        quantity: 1,
        max_tarif: null,
        keterangan: '',
        errors: {
          code: {},
          quantity: {},
          max_tarif: {},
          keterangan: {}
        }
      };
      this.$refs['form-tindakan'].show();
    },
    searchObatBpjs: debounce(function(val) {
      this.getOptionObatBpjs(val);
    }, 300),
    searchObatBpjsIzidok: debounce(function(val) {
      this.getOptionObatBpjsIzidok(val);
    }, 350),
    openObatBpjsForm() {
      this.formObatBpjs = {
        code: null,
        codeIzidok: null,
        stokObatIzidok: null,
        quantity: 1,
        sedia: null,
        keterangan: '',
        errors: {
          code: {},
          codeIzidok: {},
          quantity: {},
          sedia: {},
          keterangan: {}
        }
      };
      this.$refs['form-obat'].show();
    },
    closeTindakanBpjsForm() {
      this.$refs['form-tindakan'].hide();
    },
    closeObatBpjsForm() {
      this.$refs['form-obat'].hide();
    },
    isFromTindakanBpjsValid() {
      this.inputTindakanBpjs(this.formTindakanBpjs.code);

      const errors = this.formTindakanBpjs.errors;
      for (const item in errors) {
        if (errors[item].status) return false;
      }

      return true;
    },
    isFromObatBpjsValid() {
      this.inputObatBpjs(this.formObatBpjs.code);

      if(this.formObatBpjs.codeIzidok){
        this.inputObatBpjsIzidok(this.formObatBpjs.codeIzidok);
      }

      const errors = this.formObatBpjs.errors;
      for (const item in errors) {
        if (errors[item].status) return false;
      }

      return true;
    },
    inputTindakanBpjs(value) {
      this.formTindakanBpjs.errors.code = {};

      if (Object(value).hasOwnProperty('label')) {
        this.formTindakanBpjs.max_tarif = value.maxTarif;
      } else {
        this.formTindakanBpjs.errors.code.status = true;
        this.formTindakanBpjs.errors.code.message = 'Wajib diisi';
        return;
      }

      for (const item of this.tindakanBpjsList) {
        if (item.code == value.id) {
          this.formTindakanBpjs.errors.code.status = true;
          this.formTindakanBpjs.errors.code.message =
            'Tindakan tidak boleh sama';
          return;
        }
      }
    },
    inputObatBpjs(value) {
      this.formObatBpjs.errors.code = {};

      if (Object(value).hasOwnProperty('label')) {
        this.formObatBpjs.sedia = value.sedia;
      } else {
        this.formObatBpjs.errors.code.status = true;
        this.formObatBpjs.errors.code.message = 'Wajib diisi';
        return;
      }

      for (const item of this.obatBpjsList) {
        if (item.code == value.id) {
          this.formObatBpjs.errors.code.status = true;
          this.formObatBpjs.errors.code.message = 'Obat tidak boleh sama';
          return;
        }
      }
    },
    inputObatBpjsIzidok(value) {
      this.formObatBpjs.errors.codeIzidok = {};
      this.formObatBpjs.stokObatIzidok = value.stok;

      if(value.stok === null){
        return;
      }

      if (toInteger(this.formObatBpjs.quantity) > toInteger(value.stok)) {
        this.formObatBpjs.errors.codeIzidok.status = true;
        this.formObatBpjs.errors.codeIzidok.message = 'Stok kurang';
      }
    },
    addTindakanBpjs() {
      let {
        formTindakanBpjs: { code, quantity, max_tarif, keterangan }
      } = this;

      max_tarif = Number(max_tarif.replace(/[^0-9-]+/g, ''));

      if (!this.isFromTindakanBpjsValid()) return;

      this.tindakanBpjsList.unshift({
        code: code.id,
        nama: code.name,
        quantity: quantity,
        max_tarif: max_tarif,
        keterangan: keterangan,
        from_bpjs: 1
      });

      this.tindakanBpjsListTemp = this.tindakanBpjsList;
      this.updatePostData({
        key: 'formTindakanBpjs',
        value: this.tindakanBpjsList
      });
      this.fetchListTindakanBpjs();
      this.closeTindakanBpjsForm();
    },
    addObatBpjs() {
      let {
        formObatBpjs: { code, codeIzidok, quantity, sedia, keterangan }
      } = this;

      if (!this.isFromObatBpjsValid()) return;

      this.obatBpjsList.unshift({
        code: code.id,
        codeIzidok: codeIzidok ? codeIzidok.id : null,
        nama: code.name,
        nama_izidok: codeIzidok ? codeIzidok.label : null,
        quantity: quantity,
        sedia: sedia,
        keterangan: keterangan,
        from_bpjs: 1
      });

      this.obatBpjsListTemp = this.obatBpjsList;
      this.updatePostData({
        key: 'formObatBpjs',
        value: this.obatBpjsList
      });
      this.fetchListObatBpjs();
      this.closeObatBpjsForm();
    },
    deleteTindakanBpjs(code) {
      this.tindakanBpjsList = this.tindakanBpjsList.filter(
        item => item.code !== code
      );
      this.tindakanBpjsListTemp = this.tindakanBpjsList;
      this.fetchListTindakanBpjs();
      this.updatePostData({
        key: 'formTindakanBpjs',
        value: this.tindakanBpjsList
      });
    },
    deleteObatBpjs(code) {
      this.obatBpjsList = this.obatBpjsList.filter(item => item.code !== code);
      this.obatBpjsListTemp = this.obatBpjsList;
      this.fetchListObatBpjs();
      this.updatePostData({
        key: 'formObatBpjs',
        value: this.obatBpjsList
      });
    },
    handleValueChangedTindakanBpjs({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPageTindakan = _)));
      currentPage && (currentPage |> (_ => (this.currentPageTindakan = _)));
    },
    handleValueChangedObatBpjs({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPageObat = _)));
      currentPage && (currentPage |> (_ => (this.currentPageObat = _)));
    },
    checkStock(index) {
      let result = false;
      const tmpInput = this.tmpInputLayanan.filter(t => t.type == 'obat_bhp');
      const { qty, selectedLayanan } = tmpInput[index];
      if (selectedLayanan && !this.disabledTindakan) {
        if (
          selectedLayanan.stok != null &&
          (selectedLayanan.stok < qty || selectedLayanan.stok == 0) &&
          ['obat', 'bahan habis pakai'].includes(
            selectedLayanan.kategori_layanan.toLowerCase()
          )
        ) {
          result = true;
        }
      }
      return result;
    },
    setTatalaksanaData(d) {
      if (d.tatalaksana && d.tatalaksana.is_draw) {
        this.tatalaksana = d.tatalaksana.notes;
        if (d.tatalaksana.draw_path != null) {
          this.imgTatalaksana = d.tatalaksana.draw_path;
          this.updatePostData({ key: 'tatalaksana_is_draw', value: true });
        }
      } else {
        this.tatalaksana = d.tatalaksana ? d.tatalaksana.notes : null;
      }

      if (d.transklinik.pembayaran.length > 0) {
        d.transklinik.pembayaran.map(p => {
          if (p.status == 'LUNAS') {
            this.disabledTindakan = true;
            this.updatePostData({
              key: 'lunas',
              value: true
            });
          } else {
            this.updatePostData({
              key: 'lunas',
              value: false
            });
          }

          if (p.detail.length > 0) {
            const inputLayanan = p.detail.filter(
              item => item.from_bpjs == 0 && !item.is_resep
            );
            const inputTindakanBpjs = p.detail.filter(
              item => item.from_bpjs == 1 && item.bpjs_sk_type == 0
            );
            const inputObatBpjs = p.detail.filter(
              item => item.from_bpjs == 1 && item.bpjs_sk_type == 1
            );

            if (inputLayanan.length > 0) {
              this.tmpInputLayanan = [
                ...inputLayanan.map(item => {
                  let stock = null;
                  if (item.layanan) {
                    if (item.layanan.stok == 0) stock = 0;
                    else stock = item.layanan.stok;
                  }
                  let kategori_layanan =
                    item.layanan &&
                    item.layanan.kategori_layanan &&
                    item.layanan.kategori_layanan.nama
                      ? item.layanan.kategori_layanan.nama
                      : '-';
                  return {
                    ...item,
                    qty: item.quantity,
                    selectedLayanan: {
                      id: item.layanan_id,
                      value: item.layanan_id,
                      kode_layanan: item.kode_layanan,
                      nama_layanan: item.nama_layanan,
                      tarif: item.tarif,
                      label: item.nama_layanan,
                      stok: stock,
                      kategori_layanan: kategori_layanan,
                      satuan: item.satuan ? item.satuan.name || '-' : '-',
                      satuan_id: item.satuan_id ? item.satuan.id || '-' : '-',
                      nama_satuan: item.satuan ? item.satuan.name || '-' : '-',
                      is_resep: item.is_resep || false
                    },
                    satuan: item.satuan ? item.satuan.name || '-' : '-',
                    keterangan: item.keterangan,
                    aturan_pakai: item.aturan_pakai,
                    checkbox: false,
                    stok: stock,
                    kategori_layanan: kategori_layanan,
                    type: ['obat', 'bahan habis pakai'].includes(
                      kategori_layanan.toLowerCase()
                    )
                      ? 'obat_bhp'
                      : 'tindakan'
                  };
                })
              ];

              let obatBhpIsExist = false;
              let tindakanIsExist = false;
              this.tmpInputLayanan.forEach(item => {
                if (item.type == 'obat_bhp') {
                  obatBhpIsExist = true;
                }
                if (item.type == 'tindakan') {
                  tindakanIsExist = true;
                }
              });

              if (!tindakanIsExist) {
                this.tmpInputLayanan.push({
                  qty: 1,
                  layanan_id: null,
                  selectedLayanan: null,
                  keterangan: null,
                  satuan: null,
                  aturan_pakai: null,
                  checkbox: false,
                  type: 'tindakan'
                });
              }

              if (!obatBhpIsExist) {
                this.tmpInputLayanan.push({
                  qty: 1,
                  layanan_id: null,
                  selectedLayanan: null,
                  keterangan: null,
                  satuan: null,
                  aturan_pakai: null,
                  checkbox: false,
                  type: 'obat_bhp'
                });
              }
            } else {
              this.tmpInputLayanan = this.defaultLayanan();
            }

            this.tindakanBpjsList = [
              ...inputTindakanBpjs.map(item => {
                return {
                  code: item.kode_layanan,
                  nama: item.nama_layanan,
                  quantity: item.quantity,
                  max_tarif: item.subtotal_tarif_net,
                  keterangan: item.keterangan
                };
              })
            ];

            this.obatBpjsList = [
              ...inputObatBpjs.map(item => {
                return {
                  code: item.kode_layanan,
                  codeIzidok: item.layanan ? item.layanan.id : null,
                  nama_izidok: item.layanan ? item.layanan.nama_layanan : null,
                  nama: item.nama_layanan,
                  quantity: item.quantity,
                  sedia: item.bpjs_sedia || '-',
                  keterangan: item.keterangan,
                  from_bpjs: 1
                };
              })
            ];

            this.obatBpjsListTemp = this.obatBpjsList;
            this.tindakanBpjsListTemp = this.tindakanBpjsList;
          }

          this.updatePostData({
            key: 'formObatBpjs',
            value: this.obatBpjsList
          });

          this.updatePostData({
            key: 'formTindakanBpjs',
            value: this.tindakanBpjsList
          });

          this.tmpInputCopyRecipe = this.tmpInputLayanan;
          this.updatePostData({
            key: 'tatalaksana',
            value: this.tmpInputLayanan
          });
        });
      }
    },
    imgTatalaksanaChanged() {
      let self = this;
      self.image_url = self.imgTatalaksana;
      self.clear();
      self.drawBackground(self.image_url);
    },
    // draw the image
    drawBackground(image_url) {
      let self = this;
      let canvas = document.getElementById('tatalaksana-canvas'),
        ctx = canvas.getContext('2d'),
        img_tatalaksana = document.getElementById('img_tatalaksana');
      let backgroundURL = image_url;

      let background = new Image();
      background.crossOrigin = 'Anonymous';
      background.src = backgroundURL;

      // remove existing image
      if (img_tatalaksana.hasChildNodes()) {
        img_tatalaksana.innerHTML = '';
      }

      background.onload = function() {
        let newSize = { width: self.canvasWidth, height: self.canvasHeight };
        ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
      };
      this.isDrawing = true;
    },
    handleMousedown(e) {
      this.lastPos = this.getMousePos(e);
      this.ctx.lineWidth = this.penWidth;
      this.drawing = true;
    },
    handleMouseup(e) {
      this.drawing = false;
    },
    handleMousemove(e) {
      this.mousePos = this.getMousePos(e);
      if (this.drawing) {
        this.ctx.beginPath();
        if (this.isPen) {
          this.ctx.globalCompositeOperation = 'source-over';
          this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
          this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
          this.ctx.stroke();
        } else {
          this.ctx.globalCompositeOperation = 'destination-out';
          this.ctx.arc(
            this.mousePos.x,
            this.mousePos.y,
            this.penWidth,
            0,
            Math.PI * 2,
            false
          );
          this.ctx.fill();
        }
        this.lastPos = this.mousePos;
      }
    },
    handleTouchstart(event) {
      this.mousePos = this.getTouchPos(event);
      let touch = event.touches[0];
      let mouseEvent = new MouseEvent('mousedown', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.canvas.dispatchEvent(mouseEvent);
    },
    handleTouchend(event) {
      let mouseEvent = new MouseEvent('mouseup', {});
      this.canvas.dispatchEvent(mouseEvent);
    },
    handleTouchmove(event) {
      let touch = event.touches[0];
      let mouseEvent = new MouseEvent('mousemove', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.canvas.dispatchEvent(mouseEvent);
    },
    getMousePos(mouseEvent) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: mouseEvent.clientX - rect.left,
        y: mouseEvent.clientY - rect.top
      };
    },
    getTouchPos(touchEvent) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    },
    penColor(color) {
      this.ctx.strokeStyle = color;
    },
    clear() {
      this.canvas.width = this.canvas.width;
      this.isDrawing = false;
    },
    async getLayananTindakan(search = '') {
      const poli_id = [localStorage.getItem('poli_id')];
      const res = await this.$axios.get(
        `getalllayanan?klinik_id=${this.getKlinikId}&type=tindakan&poliklinik=${poli_id}&nama_layanan=${search}`
      );

      const { success, data } = res.data;
      if (success) {
        let opt = [];
        data.map(item => {
          opt.push({
            ...item,
            value: item.id,
            label: item.nama_layanan
          });
        });
        this.optionLayananTindakan = opt;
      }
    },
    async getLayananObatGeneral(search = '') {
      const poli_id = [localStorage.getItem('poli_id')];
      const res = await this.$axios.get(
        `getalllayanan?klinik_id=${this.getKlinikId}&type=obat_bhp&poliklinik=${poli_id}&nama_layanan=${search}`
      );

      const { success, data } = res.data;
      let opt = [];
      if (success) {
        data.map(item => {
          opt.push({
            ...item,
            value: item.id,
            label: item.nama_layanan
          });
        });
      }

      return opt;
    },
    async getLayananObatBHP(search = '') {
      this.optionLayananObatBHP = await this.getLayananObatGeneral(search);
    },
    async getOptionObatBpjsIzidok(search = '') {
      try {
        const res = await this.$axios.get(
          `getalllayanan?klinik_id=${this.getKlinikId}&type=obat_bhp&poliklinik=${localStorage.getItem('poli_id')}&nama_layanan=${search}&limit=10`
        );

        this.optionObatBpjsIzidok = res.data.data.map(item => {
          return {
            id: item.id,
            label: item.nama_layanan,
            stok: item.stok
          };
        });
      } catch (error) {
        // console.log(error);
      }
    },
    addInputLayanan(type = 'obat_bhp') {
      const { tmpInputLayanan } = this;
      const lastIndex = tmpInputLayanan[tmpInputLayanan.length - 1];
      const x = Object.keys(lastIndex);

      const tmp = x.reduce((obj, key) => {
        if (key === 'id') {
          obj[key] = tmpInputLayanan.length + 1;
        } else if (key == 'qty') {
          obj[key] = 1;
        } else {
          obj[key] = null;
        }
        if (type && type != '') obj['type'] = type;
        return obj;
      }, {});
      this.tmpInputLayanan = [...tmpInputLayanan, tmp];
    },
    removeLayanan(index, type = 'obat_bhp') {
      const { tmpInputLayanan } = this;
      if (tmpInputLayanan.length > 1) {
        const tmpLayanan = tmpInputLayanan.filter(t => t.type == type);
        const tmp = tmpLayanan
          .slice(0, index)
          .concat(tmpLayanan.slice(index + 1, tmpLayanan.length));
        const tmpX = tmpInputLayanan.filter(t => t.type != type);
        this.tmpInputLayanan = [...tmp, ...tmpX];
        this.setLayanan();
      }
    },
    async setLayanan() {
      let layanan = null;

      let tmp = [
        ...this.tmpInputLayanan.map(item => {
          item.satuan = null;
          if (item.selectedLayanan != null) {
            item.satuan = item.selectedLayanan.satuan || '-';
            layanan = {
              layanan_id: item.selectedLayanan.id,
              satuan_id: item.selectedLayanan.satuan_id,
              nama_layanan: item.selectedLayanan.nama_layanan,
              kategori_layanan: item.selectedLayanan.kategori_layanan,
              nama_satuan: item.selectedLayanan.nama_satuan,
              satuan: item.selectedLayanan.satuan,
              checkbox: item.checkbox,
              stok: item.selectedLayanan.stok,
              type: ['obat', 'bahan habis pakai'].includes(
                item.selectedLayanan.kategori_layanan.toLowerCase()
              )
                ? 'obat_bhp'
                : 'tindakan'
            };
          } else {
            layanan = {
              layanan_id: null
            };
          }

          return {
            ...layanan,
            quantity: item.qty,
            keterangan: item.keterangan,
            aturan_pakai: item.aturan_pakai
          };
        })
      ];

      this.tmpInputCopyRecipe = tmp;
      this.updatePostData({
        key: 'tatalaksana',
        value: tmp
      });
    },
    checkInput($event) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^0-9]/.test(key)) {
        evt.preventDefault();
      } else {
      }
    },
    modalRecipe() {
      this.infoPasien = {
        name: this.pasien.nama || '-',
        tanggal_lahir: moment(this.pasien.tanggal_lahir).format('DD/MM/YYYY'),
        usia: `${this.pasien.age_year} tahun ${this.pasien.age_month} bulan ${this.pasien.age_day} hari`,
        jenis_kelamin:
          this.pasien.jenis_kelamin == 1 ? 'Laki-Laki' : 'Perempuan',
        nomor_rekam_medis: this.pasien.nomor_rekam_medis,
        dokter_name: this.trx.dokter_name || '-',
        sip_dokter: this.trx.sip_dokter || '-',
        tanggal_resep: moment().format('DD/MM/YYYY')
      };
      let recipe = [],
        layanan = [];
      if (this.tmpInputLayanan.length > 0) {
        this.tmpInputLayanan.forEach(d => {
          if (d.checkbox) {
            let r = {};
            if (d.selectedLayanan != null) {
              let satuan = null;
              if (d.selectedLayanan.satuan && d.selectedLayanan.satuan != '-') {
                satuan = {
                  value: d.selectedLayanan.satuan_id,
                  label: d.selectedLayanan.satuan
                };
              }
              r = {
                layanan_id: d.selectedLayanan.value,
                nama_layanan: d.selectedLayanan.label,
                satuan_id: d.selectedLayanan.satuan_id,
                nama_satuan: d.selectedLayanan.satuan,
                satuan: satuan,
                selectedLayanan: d.selectedLayanan
              };
            }
            recipe.push({
              ...r,
              quantity: d.qty,
              aturan_pakai: d.aturan_pakai,
              keterangan: d.keterangan,
              type: 'obat_bhp',
              error: {
                nama_layanan: d.selectedLayanan.label ? null : 'Wajib diisi',
                quantity: d.qty ? null : 'Wajib diisi'
              }
            });
          } else {
            layanan.push(d);
          }
        });
      }

      let newRecipe = [];
      if (this.tmpInputRecipe.length > 0) {
        this.tmpInputRecipe.forEach(tmpRecipe => {
          if (tmpRecipe.nama_layanan != null) newRecipe.push(tmpRecipe);
        });
      }
      this.tmpInputRecipe = [...newRecipe, ...recipe];
      this.tmpInputRecipe =
        this.tmpInputRecipe.length > 0
          ? this.tmpInputRecipe
          : this.defaultRecipe();

      let l = [];
      if (layanan.length > 0) {
        let td = layanan.filter(v => v.type == 'tindakan');
        let ob = layanan.filter(v => v.type == 'obat_bhp');
        let t =
          td.length > 0
            ? td
            : this.defaultLayanan().filter(v => v.type == 'tindakan');
        let o =
          ob.length > 0
            ? ob
            : this.defaultLayanan().filter(v => v.type == 'obat_bhp');
        l = [...t, ...o];
      } else {
        l = this.defaultLayanan();
      }
      this.tmpInputLayanan = l;

      this.setLayanan();
      this.$refs['form-recipe'].show();
    },
    closeRecipe() {
      if (!this.checkNoRecipe()) {
        let layanan = [];
        this.tmpInputRecipe.forEach(r => {
          if (r.layanan_id) {
            layanan.push({
              selectedLayanan: {
                ...r.selectedLayanan,
                value: r.layanan_id,
                label: r.nama_layanan,
                satuan: r.nama_satuan
              },
              layanan_id: r.layanan_id,
              qty: r.quantity,
              satuan_id: r.satuan_id,
              satuan: r.nama_satuan ? r.nama_satuan : '-',
              aturan_pakai: r.aturan_pakai,
              keterangan: r.keterangan,
              type: 'obat_bhp'
            });
          }
        });
        let newLayanan = [];
        this.tmpInputLayanan.forEach(l => {
          if (l.selectedLayanan && l.selectedLayanan.value) newLayanan.push(l);
          else if (l.type == 'tindakan') newLayanan.push(l);
        });
        layanan =
          layanan.length > 0
            ? layanan
            : this.defaultLayanan().filter(v => v.type == 'obat_bhp');
        let dataLayanan = [...newLayanan, ...layanan];
        this.tmpInputLayanan =
          dataLayanan.length > 0 ? dataLayanan : this.defaultLayanan();
        this.tmpInputRecipe = this.defaultRecipe();

        this.setLayanan();
      }
      this.$refs['form-recipe'].hide();
    },
    async downloadRecipe(type) {
      try {
        let filename = null;
        if (this.dataRecipe.transklinik) {
          filename = this.dataRecipe.transklinik.no_resep;
        } else {
          filename = `Resep-${moment().format('DD/MM/YY')}-${this.pasien.nama}`;
        }
        let trans_id = this.$router.currentRoute.params.transklinik_id;
        const res = await this.$axios.get(
          `resep/download/${trans_id}`,
          { responseType: 'blob' }
        );
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        if (type == 'cetak') {
          let myWindow = window.open(url, '_blank');
          setTimeout(() => {
            myWindow.print();
          }, 500);
          return;
        }

        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {}
    },
    async previewRecipe(type) {
      try {
        let trans_id = this.$router.currentRoute.params.transklinik_id;
        const res = await this.$axios.get(
          `resep/preview/${trans_id}`
        );

        let myWindow = window.open('', '_blank');
        myWindow.document.write(res.data);
        myWindow.document.close();
        if (type == 'cetak') {
          setTimeout(() => {
            myWindow.focus();
            myWindow.print();
            myWindow.close();
          }, 500);
        }
      } catch (error) {}
    },
    async deleteRecipe() {
      try {
        let trans_id = this.$router.currentRoute.params.transklinik_id;
        const res = await this.$axios.delete(`resep/${trans_id}`);
        const { status, message } = res.data;

        if (status) {
          this.$swal({
            text: 'Resep berhasil dihapus',
            type: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(r => {
            this.tmpInputRecipe = this.defaultRecipe();
            this.dataRecipe = {
              detail_pembayaran: null,
              transklinik: null
            };
          });
        } else {
          this.$swal({
            text: message,
            type: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false
          });
        }
      } catch (error) {}
    },
    validateRecipe() {
      let check = [];
      this.tmpInputRecipe.forEach((r, i) => {
        if (
          r.nama_layanan == null ||
          r.nama_layanan == '' ||
          r.nama_layanan == undefined
        ) {
          this.tmpInputRecipe[i].error['nama_layanan'] = 'Wajib diisi';
          check.push(true);
        } else {
          this.tmpInputRecipe[i].error['nama_layanan'] = null;
        }

        if (r.quantity == null || r.quantity == '' || r.quantity == undefined) {
          this.tmpInputRecipe[i].error['quantity'] = 'Wajib diisi';
          check.push(true);
        } else {
          this.tmpInputRecipe[i].error['quantity'] = null;
        }
      });
      return check.length > 0;
    },
    async saveRecipe(type) {
      try {
        if (this.validateRecipe()) return;

        let res = null,
          resep = this.tmpInputRecipe.map(r => {
            return {
              layanan_id: r.layanan_id,
              nama_layanan: r.nama_layanan,
              satuan_id: r.satuan_id,
              nama_satuan: r.nama_satuan,
              quantity: r.quantity,
              aturan_pakai: r.aturan_pakai,
              keterangan: r.keterangan
            };
          });
        if (this.checkNoRecipe()) {
          res = await this.$axios.put(`resep`, {
            transklinik_id: this.trx.id,
            resep: resep
          });
        } else {
          res = await this.$axios.post(`resep`, {
            transklinik_id: this.trx.id,
            no_resep: `Resep-${moment().format('DD/MM/YY')}-${
              this.pasien.nama
            }`,
            resep: resep
          });
        }
        const { status } = res.data;

        if (status) {
          this.$refs['form-recipe'].hide();
          if (type == 'save') {
            this.$swal({
              text: 'Resep berhasil disimpan',
              type: 'success',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then(r => {
              this.getRecipe();
            });
          } else {
            await this.getRecipe();
            await this.downloadRecipe(type);
          }
        }
      } catch (error) {}
    },
    async getRecipe(type) {
      try {
        let trans_id = this.$router.currentRoute.params.transklinik_id;
        const res = await this.$axios.get(`resep/${trans_id}`);
        const { status, data } = res.data;
        if (status) {
          this.dataRecipe = data;
          if (data.detail_pembayaran) {
            this.tmpInputRecipe = data.detail_pembayaran.map(d => {
              return {
                ...d,
                satuan: {
                  value: d.satuan_id,
                  label: d.nama_satuan
                },
                error: {
                  nama_layanan: null,
                  quantity: null
                }
              };
            });
          } else {
            this.tmpInputRecipe = this.defaultRecipe();
          }
          this.checkNoRecipe();
          if (type == 'edit') this.modalRecipe();
        }
      } catch (error) {}
    },
    checkNoRecipe() {
      let r = this.dataRecipe;
      if (r && r.transklinik && r.transklinik.no_resep) return true;
      else return false;
    },
    checkSelectedLayanan(selected) {
      if (selected == null) {
        return true;
      } else if (selected.kategori_layanan) {
        if (
          !['obat', 'bahan habis pakai'].includes(
            selected.kategori_layanan.toLowerCase()
          )
        )
          return true;
      }
      return false;
    },
    removeLayananRecipe(index) {
      const { tmpInputRecipe } = this;
      if (tmpInputRecipe.length > 1) {
        const tmp = tmpInputRecipe
          .slice(0, index)
          .concat(tmpInputRecipe.slice(index + 1, tmpInputRecipe.length));
        this.tmpInputRecipe = tmp;
        this.setLayananRecipe();
      }
    },
    setLayananRecipe() {
      let tmp = [
        ...this.tmpInputRecipe.map(item => {
          return {
            ...item,
            satuan_id: item.satuan ? item.satuan.value : null,
            nama_satuan: item.satuan ? item.satuan.label : null
          };
        })
      ];
      this.tmpInputRecipe = tmp;
    },
    addInputLayananRecipe() {
      const { tmpInputRecipe } = this;
      const lastIndex = tmpInputRecipe[tmpInputRecipe.length - 1];
      const x = Object.keys(lastIndex);

      const tmp = x.reduce((obj, key) => {
        if (key === 'id') {
          obj[key] = tmpInputRecipe.length + 1;
        } else if (key == 'quantity') {
          obj[key] = 1;
        } else if (key == 'error') {
          obj[key] = {
            nama_layanan: null,
            quantity: null
          };
        } else {
          obj[key] = null;
        }
        return obj;
      }, {});
      this.tmpInputRecipe = [...tmpInputRecipe, tmp];
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    klinik() {
      this.klinikUser.forEach(x => {
        if (x.id == this.getKlinikId) this.dataKlinik = x;
      });
    },
    hasFeatures(value) {
      const features = {
        all: ['dokter_klinik'],
        preview: ['apoteker', 'perawat'],
        cetak: ['frontdesk', 'kasir', 'pic_cabang', 'pic_pusat']
      };
      const roles = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return roles.length > 0 ? true : false;
    },
    defaultLayanan() {
      return [
        {
          qty: 1,
          layanan_id: null,
          selectedLayanan: null,
          keterangan: null,
          satuan: null,
          aturan_pakai: null,
          checkbox: false,
          type: 'tindakan'
        },
        {
          qty: 1,
          layanan_id: null,
          selectedLayanan: null,
          keterangan: null,
          satuan: null,
          aturan_pakai: null,
          checkbox: false,
          type: 'obat_bhp'
        }
      ];
    },
    defaultRecipe() {
      return [
        {
          layanan_id: null,
          nama_layanan: null,
          quantity: 1,
          satuan_id: null,
          nama_satuan: null,
          satuan: null,
          aturan_pakai: null,
          keterangan: null,
          error: {
            nama_layanan: null,
            quantity: null
          }
        }
      ];
    },
    renameRecipe(name) {
      let width = window.innerWidth;
      return name.substring(0, Math.ceil(width / 40));
    },
    setAlergiKondisiKhusus(data) {
      let result = [];
      if (this.checkValueData(data.riwayat_penyakit)) {
        result.push({ label: `Riwayat Penyakit: ${data.riwayat_penyakit}` });
      }
      if (this.checkValueData(data.riwayat_alergi_obat)) {
        let obtLabel = `Alergi Obat: ${data.riwayat_alergi_obat}`;
        if (data.riwayat_alergi_obat.toLowerCase().includes('lain') && this.pcareVersion == '1') obtLabel += `, Keterangan Lain: ${data.ket_riwayat_alergi_obat}`;
        result.push({ label: obtLabel });
      }
      if (this.checkValueData(data.riwayat_alergi_makanan)) {
        let mknLabel = `Alergi Makanan: ${data.riwayat_alergi_makanan}`;
        if (data.riwayat_alergi_makanan.toLowerCase().includes('lain') && this.pcareVersion == '1') mknLabel += `, Keterangan Lain: ${data.ket_riwayat_alergi_makanan}`;
        result.push({ label: mknLabel });
      }
      if (this.checkValueData(data.riwayat_alergi_udara)) {
        result.push({ label: `Alergi Udara: ${data.riwayat_alergi_udara}` });
      }
      if (this.checkValueData(data.riwayat_alergi_lain)) {
        result.push({ label: `Alergi Lain: ${data.riwayat_alergi_lain}` });
      }
      if (this.checkValueData(data.riwayat_pengobatan)) {
        result.push({ label: `Riwayat Pengobatan: ${data.riwayat_pengobatan}` });
      }
      if (this.checkValueData(data.keterangan_lain)) {
        result.push({ label: `Keterangan Lain: ${data.keterangan_lain}` });
      }
      return result.map((r, i) => {
        return {
          ...r,
          class: `badge-pill badge-custom color_${i}`
        };
      });
    },
    setDrawPostData(type) {
      if (type == 'pen') {
        this.isPen = true;
        this.isHidden = false;
        this.isDrawing = true;
      } else if (type == 'eraser') {
        this.isPen = false;
        this.isHidden = false;
      } else {
        this.isPen = false;
        this.isHidden = true;
      }
      this.isActive = type;
      this.updatePostData({
        key: 'tatalaksana_is_draw',
        value: this.isDrawing
      });
    },
    checkQuantity($event) {
      this.formObatBpjs.errors.codeIzidok = {};

      if(this.formObatBpjs.stokObatIzidok === null){
        return;
      }

      if (
        this.formObatBpjs.codeIzidok &&
        toInteger(this.formObatBpjs.stokObatIzidok) <
          toInteger(this.formObatBpjs.quantity)
      ) {
        this.formObatBpjs.errors.codeIzidok.status = true;
        this.formObatBpjs.errors.codeIzidok.message = 'Stok kurang';
      }
    },
    terapiObatKeyupHanlder() {
      this.$emit('update-terapi-obat-touched', true);
    },
    terapiObatInputHanlder() {
      this.updatePostData({
        key: 'terapi_obat',
        value: this.terapiObat
      });
    },
    terapiNonObatKeyupHanlder() {
      this.$emit('update-terapi-non-obat-touched', true);
    },
    terapiNonObatInputHanlder() {
      this.updatePostData({
        key: 'terapi_non_obat',
        value: this.terapiNonObat
      });
    },
    bmhpInputHanlder() {
      this.updatePostData({
        key: 'bmhp',
        value: this.bmhp
      });
    },
    dataCopyReceipe() {
      let status = false;
      let result = [];

      const tmpObat = this.tmpInputCopyRecipe.filter(v => v.kategori_layanan == 'Obat');
      if (tmpObat.length > 0) {
        tmpObat.forEach(tmp => {
          result.push(tmp);
        });

        const qtyTotal = result.reduce((a, b) => a + b.quantity,0);
        if (qtyTotal > 0 && tmpObat.length > 0) status = true;
      }
      return {result, status}
    },
    checkCopyRecipe() {
      const { status } = this.dataCopyReceipe();
      return status;
    },
    async printCopyRecipe() {
      try {
        let trans_id = this.$router.currentRoute.params.transklinik_id;
        const { result } = this.dataCopyReceipe();

        const detail = result.map(v => ({...v, nama_satuan: v.satuan}));
        if (this.obatBpjsList.length > 0) {
          this.obatBpjsList.forEach(v => {
            detail.push({
              ...v,
              nama_layanan: v.nama,
              nama_satuan: null,
              aturan_pakai: null,
            })
          })
        }
        const res = await this.$axios.post(`copy-resep/${trans_id}`, {detail}, {
          responseType: 'blob'
        });
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        let myWindow = window.open(url, '_blank');
        myWindow.print();
      } catch (error) {}
    },
  }
};
</script>

<style scoped>
.__zoom-out-ttl {
  zoom: 83%;
}

.outer-tatalaksana {
  padding: 8px;
  font-weight: 800;
  color: red;
  background-color: #fcedea;
  outline-color: red;
  border: 1px solid red;
  outline-style: solid;
  outline-width: thin;
}

canvas {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  cursor: crosshair;
}

#tatalaksana-canvas {
  touch-action: none;
}

.btn-recipe {
  color: #fff;
  background-color: #0edb1c;
  border-color: #0edb1c;
  border-radius: 5px;
}

.btn-copy-recipe {
  color: #fff;
  background-color: #3c44b1;
  border-color: #3c44b1;
  border-radius: 5px;
}

.card-shadowless {
  box-shadow: none;
}

.card-border {
  border: 1px solid #ddd;
}

.card-info {
  background-color: #dcebff;
  border: 1px solid #dcebff;
  border-radius: 5px;
}

.info_recipe {
  margin: 0;
  font-family: "Poppins", "Heebo", sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b3e66;
  text-align: left;
}

.min-h {
  min-height: 250px;
}

.form-control[readonly] {
  background-color: #fff;
}

.text-verified {
  color: #007bff;
  font-size: 70%;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.form-tatalaksana .quill-editor .ql-toolbar {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.form-tatalaksana .quill-editor .ql-container {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.info-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
  max-width: 400px !important;
  width: 400px !important;
  text-align: left !important;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
}

.info-tooltip .tooltip-arrow {
  display: none;
}

.select_layanan
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}
#action-resep .btn-outline-success {
  border: 1px solid #1bc943;
}
#action-resep ul > li {
  font-size: 0.75rem;
}
.badge-custom {
  font-weight: normal;
  color: #fff;
  margin-right: 1rem;
}
.color_0 {
  background-color: #690108;
}
.color_1 {
  background-color: #95020c;
}
.color_2 {
  background-color: #9d1e18;
}
.color_3 {
  background-color: #b90b04;
}
.color_4 {
  background-color: #e3321e;
}
.color_5 {
  background-color: #fd7342;
}
.color_6 {
  background-color: #fe7443;
}
.color_7 {
  background-color: #fc8053;
}
.color_8 {
  background-color: #fd9670;
}
.form-tatalaksana .quill-editor .ql-container {
  color: #505050;
  font-size: 14px;
}
@media screen and (max-width: 1400px) {
  .form-tatalaksana .quill-editor .ql-toolbar {
    zoom: 85%;
  }
}
@media screen and (max-width: 1024px) {
  .form-tatalaksana .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-tatalaksana .quill-editor .ql-container {
    color: #505050;
    font-size: 12px;
  }
}
</style>
